import React from "react";
import Tabs from "components/Tab/Tabs";
import { DATA_TABLE_GUTTER_CLASS } from "components/DataTable/gutter";
import RouterInfoTab from "./RouterInfoTab/RouterInfoTab";
import DeviceSettings from "pages/tracking/settings/DeviceSettings";

const OrgSettings: React.FC = () => {
  const tabData = [
    {
      label: "Router Info",
      content: <RouterInfoTab />,
    },
    {
      label: "Device Settings",
      content: <DeviceSettings />,
    },
  ];

  return (
    // 1. Use flex column
    // 2. Set a height. Adjust `calc(100vh - 100px)` based on your app's top navbar height
    <div className=" flex flex-col h-[calc(100vh-100px)] w-full">
      {/* <BreadCrumb BreadCrumbList={BreadCrumbList} /> */}

      {/* 3. Make this wrapper take up all remaining flex space */}
      <div className="flex-1 min-h-0">
        <Tabs
          tabs={tabData}
          contentClassName="pt-0"
          barClassName={DATA_TABLE_GUTTER_CLASS}
          onTabChange={() => { }}
        />
      </div>
    </div>
  );
};

export default OrgSettings;